import React from 'react';

export const CorporateFooter = ({ t }) => {
  return (
    <footer className="bg-gray-900 text-white py-6 sm:py-8" data-testid="home-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-lg sm:text-xl font-semibold mb-2" data-testid="home-footer-since-text">{t('hero.since')} 🙏</p>
        <p className="text-sm sm:text-base" data-testid="home-footer-rights-text">&copy; {new Date().getFullYear()} RH Consulting Holdings. {t('footer.rights')}</p>
      </div>
    </footer>
  );
};
